import { render, staticRenderFns } from "./CandidateFilters.vue?vue&type=template&id=744579c4&"
import script from "./CandidateFilters.vue?vue&type=script&lang=js&"
export * from "./CandidateFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports